import React, { Component } from "react";

import robot from "../../assets/img/robot.png";

class NotFound extends Component {
  render() {
    return (
      <div className="NotFound">
        <div className="uk-card uk-card-default uk-card-body">
          <div className="uk-flex uk-flex-column uk-flex-middle">
            <img className="uk-img" src={robot} width="256" />
            <h3 className="uk-text-lead uk-text-bold uk-margin-remove-bottom">
              Opps! Page not Found
            </h3>
            <h2>We are sorry, but this is not the page you are looking for</h2>
            <button
              className="uk-button uk-button-primary uk-margin-top"
              type="button"
              onClick={() => this.props.history.replace("/merchants")}
            >
              <span className="uk-text-middle uk-text-bold">Back to Home</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFound;
